import {doGet} from './Base';


const getMessageViews = async(message) => {
  const url = '/reports/' + message.message_id + '/views?limit=20';
  const response_json = await doGet(url);
  return response_json.views;
}

export default getMessageViews;
